module.exports = __webpack_public_path__ + "static/media/logos_squares_Adv_DEVB.6ae6c710.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Adv_DEVB.png
// module id = 40
// module chunks = 0